import { InfoOutlined } from "@mui/icons-material";
import { ClickAwayListener, IconButton, Tooltip } from "@mui/material";
import React from "react";

function CustomiseTooltip({ title = null, buttonSx = {} }) {
    const [open, setOpen] = React.useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = (event) => {
        setOpen(true);
    };
    return (
        <>
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={title}
                    arrow
                    componentsProps={{
                        popper: {
                            sx: {
                                zIndex: 100001,
                            },
                        },
                        tooltip: {
                            sx: {
                                padding: "12px",
                                backgroundColor: "#445274",
                                color: "#FFFFFF",
                                maxWidth: 320,
                                fontSize: "12px",
                            },
                        },
                    }}>
                    <IconButton
                        sx={{
                            p: 0,
                            marginLeft: "0.5rem",
                            ...buttonSx,
                        }}
                        onClick={handleTooltipOpen}>
                        <InfoOutlined fontSize="small" />
                    </IconButton>
                </Tooltip>
            </ClickAwayListener>
        </>
    );
}

export default CustomiseTooltip;
